import * as React from 'react';
import { RadioButtonGroup } from '@cian/ui-kit/radio';
import { SWITCHER_OPTIONS } from './constants';
import { TPlacingTypeSwitcherProps } from './types';
import * as styles from './PlacingTypeSwitcher.css';

export const PlacingTypeSwitcher = (props: TPlacingTypeSwitcherProps) => {
  const { isShow, value, handleChange } = props;

  if (!isShow) {
    return null;
  }

  return (
    <div className={styles['wrapper']}>
      <RadioButtonGroup
        name="placingType"
        options={SWITCHER_OPTIONS}
        value={value || undefined}
        onChange={handleChange}
      />
    </div>
  );
};
